import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PaymentActions, ProjectsActions } from 'redux/actions';
import {
  AddButtonWrapper,
  AddInnerModalWrapper,
  AddModal,
  Container,
  PrimaryButtonV2,
  SecondaryButton,
  SpaceBetween,
  TipBox,
} from 'utils';
import { Form, Select, Spin } from 'antd';
import {
  InfoboxTick,
  InfoIconGreen,
  InfoIconRed,
  SubmissionIcon,
  SubmissionImage,
} from 'images';
import styled from '@emotion/styled/macro';
import { Option } from 'antd/lib/mentions';

const ButtonsWrapper = styled(SpaceBetween)`
  @media (max-width: 500px) {
    flex-direction: column-reverse;
    gap: 8px;
    width: 100%;
  }
`;

const FormItem = Form.Item;
export class Submission extends Component {
  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    businessTypeMismatch: PropTypes.bool.isRequired,
    projectId: PropTypes.string,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
    handleLegitimization: PropTypes.func.isRequired,
    handleReLegitimization: PropTypes.func.isRequired,
    handleGetBusinessType: PropTypes.func.isRequired,
    handleSubmission: PropTypes.func.isRequired,
    stripeStatus: PropTypes.string.isRequired,
    getStripeStatus: PropTypes.func.isRequired,
    getBusinessType: PropTypes.func.isRequired,
    getMyProjects: PropTypes.func.isRequired,
    handleExitEditForm: PropTypes.func.isRequired,
    returnToProfile: PropTypes.func.isRequired,
    linkExistingStripeAccount: PropTypes.func.isRequired,
    editProject: PropTypes.bool.isRequired,
  };

  state = {
    showConfirmModal: false,
    showAccountModal: false,
    userProjects: [],
    showErrorModal: false,
    showStripeError: false,
    awaitLegitimization: false,
    mountCheckDone: false,
    updateAndSubmit: false,
    stripeAccount: 0,
  };

  async componentDidMount() {
    const { projectId, getStripeStatus, getMyProjects, getBusinessType, editProject } =
      this.props;
    getStripeStatus(projectId);
    getMyProjects();
    !editProject && getBusinessType(projectId);
  }

  componentDidUpdate(prevProps) {
    const { loading, stripeStatus, businessTypeMismatch, myProjects, projectId } = this.props;
    const { mountCheckDone } = this.state;
    if (!loading && !mountCheckDone) {
      let showErrorModal = false;
      if (stripeStatus !== 'no_account') {
        showErrorModal = businessTypeMismatch.mismatch;
      }
      this.setState({
        showErrorModal: showErrorModal,
        mountCheckDone: true,
        updateAndSubmit:
          stripeStatus === 'enabled' ||
          stripeStatus === 'enabled_and_eventually_due',
      });
    }
    
    if (myProjects && myProjects !== prevProps.myProjects) {
      this.setState({
        userProjects: myProjects.filter((p) => 
          p.id.toString() !== projectId.toString() &&
          ['enabled', 'enabled_and_eventually_due'].includes(p.stripe_status)
        ),
      });
    }
  }

  onFinish = () => {};

  onStartLegitimization = () => {
    const { stripeStatus, businessTypeMismatch, editProject } = this.props;
    if (stripeStatus === 'no_account') {
      this.setState({ showConfirmModal: true });
      return;
    }
    if (
      businessTypeMismatch.mismatch &&
      stripeStatus !== 'no_account' &&
      !editProject
    ) {
      this.setState({ showErrorModal: true });
      this.setState({ updateAndSubmit: false });
      return;
    }
    this.onConfirmLegitimization();
  };

  onSelectOldAccount = () => {
    this.setState({ showAccountModal: true });
  };

  onSubmit = () => {
    const { stripeStatus, businessTypeMismatch, handleSubmission } = this.props;
    if (businessTypeMismatch.mismatch && stripeStatus !== 'no_account') {
      this.setState({ showErrorModal: true });
      this.setState({ updateAndSubmit: true });
      return;
    }
    handleSubmission();
  };

  handelCloseConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  handelCloseAccountModal = () => {
    this.setState({ showAccountModal: false });
  };

  setStripeAccount = (id) => {
    const projects = this.state.userProjects;

    const selectedProject = projects.find((p) => p.id === id);
    if (!selectedProject) return;

    this.setState({ 
      stripeAccount: id,
    });
  }

  onConfirmOldAccount = () => {
    const { linkExistingStripeAccount, getStripeStatus, projectId } = this.props;
    const { stripeAccount } = this.state;
    if (!projectId || !stripeAccount) {
      this.setState({ showStripeError: true });
      return;
    }
    linkExistingStripeAccount(projectId, stripeAccount, true)
      .then(() => {
        getStripeStatus(projectId);
      });

    this.handelCloseAccountModal();
  }

  onConfirmLegitimization = () => {
    const { projectId, handleLegitimization } = this.props;
    if (projectId) {
      handleLegitimization();
      this.setState({ awaitLegitimization: true });
    }
  };

  onCancelLegitimization = () => {
    this.setState({ showConfirmModal: false });
  };

  onConfirmReLegitimization = () => {
    const { editProject, projectId, handleReLegitimization } = this.props;
    if (!editProject && projectId) {
      handleReLegitimization();
      this.setState({ awaitLegitimization: true });
    }
  };

  onSubmitAnyway = () => {
    const { businessTypeMismatch, projectId, updateDraft } = this.props;
    const values = { business_type: businessTypeMismatch.stripe_business_type };
    const submit = true;
    updateDraft(projectId, values, null, submit);
  };

  onLegitimizeAnyway = () => {
    const {
      businessTypeMismatch,
      projectId,
      updateDraft,
      handleLegitimization,
    } = this.props;
    const values = { business_type: businessTypeMismatch.stripe_business_type };
    updateDraft(projectId, values);
    handleLegitimization();
    this.setState({ awaitLegitimization: true });
  };

  onCancelReLegitimization = () => {
    this.setState({ showErrorModal: false });
  };

  handleBusinessType = () => {
    const { project } = this.props;
    const { business_type, categoryType } = project;
    if (!business_type || !categoryType)
      return 'Privatperson ("Einzelunternehmen"';
    const { country } = categoryType;

    switch (business_type) {
      case 'individual':
        if (country === 'DE')
          return 'Privatperson ("Eingetragener Kaufmann / Kauffrau"';
        else return 'Privatperson ("Einzelunternehmen"';
      case 'company':
        if (country === 'DE')
          return 'Kapitalgesellschaft ("Kapitalgesellschaft"';
        else if (country === 'AT') return 'Kapitalgesellschaft ("Gesellschaft"';
        else return 'Kapitalgesellschaft ("Unternehmen"';
      case 'non_profit':
        if (country === 'DE')
          return 'Verein oder Genossenschaft ("Verein oder Genossenschaft"';
        else if (country === 'AT')
          return 'Verein oder Genossenschaft ("Gemeinnütziges Unternehmen"';
        else return 'Verein oder Genossenschaft ("Stiftung"';
      case 'government_entity':
        return 'Personengesellschaft ("Personengesellschaft"';

      default:
        return 'Privatperson ("Einzelunternehmen"';
    }
  };

  onReturn = () => {
    const { editProject, handleExitEditForm, returnToProfile } = this.props;
    if (editProject) handleExitEditForm();
    else returnToProfile();
  };

  onContinue = () => {
    const { editProject, handleSteps } = this.props;
    if (editProject) handleSteps(8);
  }

  render() {
    const { stripeStatus, editProject, loading } = this.props;
    const { awaitLegitimization, userProjects } = this.state;

    return (
      <Container className="inside-form-container">
        <Spin spinning={loading || awaitLegitimization}>
          <Form onFinish={this.onFinish}>
            {editProject ? (
              <>
                <h1>Zahlungsabwicklung</h1>

                <p>
                  Du bist bei unserem Zahlungsdienstleister verifiziert.
                </p>
                <p>
                  IBAN-Änderungen, weitere Angaben oder angeforderte Dokumente kannst 
                  du jederzeit über den Button unten vornehmen.
                  <br />
                  Dort findest du auch eine Übersicht zu deinen Zahlungen.
                </p>
              </>
            ) : (
              <>
                <img
                  style={{ marginTop: '78px' }}
                  src={SubmissionImage}
                  alt="Submission decoration"
                />
                <h1>Dein Projekt ist (fast) bereit!</h1>

                <p>
                  Bevor es live gehen kann, musst du noch deine persönlichen Daten
                  und Bankverbindung bei unserem Zahlungspartner Stripe hinterlegen.
                  Dies ist notwendig, damit du Unterstützungen empfangen und deine
                  Auszahlungen sicher erhalten kannst.
                </p>
              </>
            )}

            <p style={{ color: '#3F621A', fontWeight: 600 }}>
              Fragen dazu?{' '}
              <a
                href="/contact-us"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'underline' }}
              >
                Kontaktiere uns hier.
              </a>
            </p>

            {stripeStatus === 'enabled' ||
            stripeStatus === 'enabled_and_eventually_due' ? (
              <TipBox>
                <img
                  style={{
                    width: '32px',
                    margin: '16px',
                    alignSelf: 'flex-start',
                  }}
                  src={InfoboxTick}
                  alt="Stripe finished icon"
                />
                <p
                  style={{
                    paddingTop: '16px',
                    paddingRight: '16px',
                    fontSize: '14px',
                  }}
                >
                  <span style={{ fontWeight: 600 }}>
                    Du hast deine Daten bei Stripe erfolgreich hinterlegt.
                  </span>{' '}
                  <br />
                  Keine weitere Aktion erforderlich.
                </p>
              </TipBox>
            ) : (
              <TipBox>
                <img
                  style={{
                    width: '32px',
                    margin: '16px',
                    alignSelf: 'flex-start',
                  }}
                  src={SubmissionIcon}
                  alt="Submission icon"
                />
                <p
                  style={{
                    paddingTop: '16px',
                    paddingRight: '16px',
                    fontSize: '14px',
                  }}
                >
                  <span style={{ fontWeight: 600 }}>
                    Vermeide Probleme mit deiner Auszahlung
                  </span>{' '}
                  <br />
                  Manchmal kann es vorkommen, dass Stripe dich später
                  kontaktiert und zusätzliche Angaben oder Nachweise anfordert.
                  Achte daher darauf, dass deine Daten korrekt sind und behalte
                  dein E-Mail-Postfach im Blick, um Verzögerungen zu vermeiden.
                </p>
              </TipBox>
            )}

            <FormItem>
              <SpaceBetween>
                {editProject ? (
                  <ButtonsWrapper>
                    <PrimaryButtonV2
                      type="primary"
                      primary={true}
                      htmltype="submit"
                      minWidth="120px"
                      id="submit-button"
                      onClick={this.onStartLegitimization}
                    >
                      <p>Zum Zahlungsdienstleister</p>
                    </PrimaryButtonV2>
                    <PrimaryButtonV2
                      type="button"
                      minWidth="120px"
                      onClick={this.onContinue}
                    >
                      <p>Weiter zur Einreichung</p>
                    </PrimaryButtonV2>
                  </ButtonsWrapper>
                ) : (
                  <ButtonsWrapper>
                    <PrimaryButtonV2
                      primary={true}
                      minWidth="186px"
                      onClick={this.onReturn}
                    >
                      <p>Später abschließen</p>
                    </PrimaryButtonV2>
                    {stripeStatus === 'enabled' ||
                    stripeStatus === 'enabled_and_eventually_due' ? (
                      <PrimaryButtonV2
                        type="primary"
                        htmltype="submit"
                        minWidth="258px"
                        id="submit-button"
                        onClick={this.onSubmit}
                      >
                        <p>Projekt einreichen</p>
                      </PrimaryButtonV2>
                    ) : (
                      <>
                        {userProjects.length > 0 ? (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <PrimaryButtonV2
                              type="primary"
                              htmltype="submit"
                              minWidth="258px"
                              id="submit-button"
                              onClick={this.onSelectOldAccount}
                            >
                              <p>Bestehendes Konto verknüpfen</p>
                            </PrimaryButtonV2>
                            <PrimaryButtonV2
                              type="primary"
                              htmltype="submit"
                              minWidth="258px"
                              id="submit-button"
                              onClick={this.onStartLegitimization}
                            >
                              <p>Neues Konto verknüpfen</p>
                            </PrimaryButtonV2>
                          </div>
                        ) : (
                          <PrimaryButtonV2
                            type="primary"
                            htmltype="submit"
                            minWidth="258px"
                            id="submit-button"
                            onClick={this.onStartLegitimization}
                          >
                            <p>Weiter zum Zahlungspartner</p>
                          </PrimaryButtonV2>
                        )}
                      </>
                    )}
                  </ButtonsWrapper>
                )}
              </SpaceBetween>
            </FormItem>
          </Form>

          <AddModal
            showModal={this.state.showConfirmModal}
            handelCloseModal={this.handelCloseConfirmModal}
            width="45%"
          >
            <AddInnerModalWrapper>
              <img
                style={{ height: '48px', width: '48px' }}
                src={InfoIconGreen}
                alt="Info icon"
              />
              <h2 style={{ fontSize: '18px' }}>Wichtiger Hinweis zu Stripe</h2>
              <p>
                Du hast bei uns angegeben, dass du als{' '}
                <b>{this.handleBusinessType()} bei Stripe)</b> Spenden sammelst.
                Diese Auswahl wird an unseren Zahlungsdienstleister Stripe
                übergeben und dort vorausgefüllt.
              </p>
              <p>
                <b>
                  Bitte ändere diese Information nicht bei Stripe, sondern
                  ergänze nur die noch fehlenden Felder.{' '}
                </b>
                <br />
                So stellst du sicher, dass deine Auszahlung reibungslos
                funktioniert.
              </p>
              <AddButtonWrapper>
                <div className="space-between">
                  <PrimaryButtonV2
                    type="button"
                    primary="true"
                    onClick={this.onCancelLegitimization}
                  >
                    <p>Abbrechen</p>
                  </PrimaryButtonV2>

                  <PrimaryButtonV2
                    type="primary"
                    onClick={this.onConfirmLegitimization}
                  >
                    <p>Einverstanden</p>
                  </PrimaryButtonV2>
                </div>
              </AddButtonWrapper>
            </AddInnerModalWrapper>
          </AddModal>

          <AddModal
            showModal={this.state.showAccountModal}
            handelCloseModal={this.handelCloseAccountModal}
            width="45%"
          >
            <AddInnerModalWrapper>
              <img
                style={{ height: '48px', width: '48px' }}
                src={InfoIconGreen}
                alt="Info icon"
              />
              <h2 style={{ fontSize: '18px' }}>Schneller starten mit deinem bestehenden Konto</h2>
              <p>
                Du hast bereits ein Projekt auf commonsplace gestartet und möchtest dieses 
                Projekt mit einem vorherigen Projekt verbinden? <br />
                Dann kannst du das bestehende Auszahlungskonto bei unserem Zahlungspartner 
                erneut nutzen und dein neues Projekt ohne erneute Verifizierung starten.
              </p>
              <p>
                <b>Hinweis:</b><br />
                Wenn dein früheres Projekt noch aktiv ist, werden Auszahlungen aus beiden 
                Projekten zunächst über dasselbe Konto abgewickelt.
              </p>
              <p>
                <b>Vorteile:</b>
                <ul>
                  <li style={{ fontSize: '14px' }}>Keine erneute Verifizierung</li>
                  <li style={{ fontSize: '14px' }}>Schneller online gehen</li>
                  <li style={{ fontSize: '14px' }}>Bereits eingerichtetes Konto weiter nutzen</li>
                  <li style={{ fontSize: '14px' }}>IBAN kann jederzeit im Konto angepasst werden</li>
                </ul>
              </p>
              <FormItem label="Früheres Projekt auswählen">
                <Select
                  style={{ width: '100%' }}
                  value={this.state.stripeAccount}
                  onChange={(value) => {
                    this.setStripeAccount(value);
                  }}
                >
                  <Option value={0}>Kein Projekt</Option>
                  {userProjects &&
                    userProjects.map((project) => (
                      <Option
                        key={`${JSON.stringify(project)}-1`}
                        value={project.id}
                      >
                        {project.name}
                      </Option>
                    ))}
                </Select>
                {this.state.showStripeError && !this.state.stripeAccount && (
                  <span style={{ color: 'red' }}>
                    Bitte wähle ein Projekt aus!
                  </span>
                )}
              </FormItem>
              <AddButtonWrapper>
                <div className="space-between">
                  <PrimaryButtonV2
                    type="button"
                    primary="true"
                    onClick={this.handelCloseAccountModal}
                  >
                    <p>Zurück</p>
                  </PrimaryButtonV2>

                  <PrimaryButtonV2
                    type="primary"
                    onClick={this.onConfirmOldAccount}
                  >
                    <p>Konto verbinden</p>
                  </PrimaryButtonV2>
                </div>
              </AddButtonWrapper>
            </AddInnerModalWrapper>
          </AddModal>

          <AddModal
            showModal={this.state.showErrorModal}
            handelCloseModal={this.onCancelReLegitimization}
            width="40%"
          >
            <AddInnerModalWrapper>
              <img
                style={{ height: '48px', width: '48px' }}
                src={InfoIconRed}
                alt="Error icon"
              />
              <h2 style={{ fontSize: '18px' }}>
                Fehlerhafte Angabe bei Stripe
              </h2>
              <p>
                <b>
                  Du hast bei Stripe einen anderen Geschäftstyp ausgewählt, als
                  bei uns angegeben.
                </b>
              </p>
              <p>Dadurch kann es zu Problemen bei deiner Auszahlung kommen.</p>
              <AddButtonWrapper>
                <div className="space-between">
                  <PrimaryButtonV2
                    type="button"
                    primary="true"
                    onClick={
                      this.state.updateAndSubmit
                        ? this.onSubmitAnyway
                        : this.onLegitimizeAnyway
                    }
                  >
                    {this.state.updateAndSubmit ? (
                      <p>Trotzdem einreichen</p>
                    ) : (
                      <p>Trotzdem legitimieren</p>
                    )}
                  </PrimaryButtonV2>

                  <PrimaryButtonV2
                    type="primary"
                    onClick={this.onConfirmReLegitimization}
                  >
                    <p>Geschäftstyp korrigieren</p>
                  </PrimaryButtonV2>
                </div>
              </AddButtonWrapper>
            </AddInnerModalWrapper>
          </AddModal>
        </Spin>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, errors, loading, currentStep, businessTypeMismatch, myProjects } =
    state.projects;
  const { stripeStatus } = state.payment;
  return {
    project,
    errors,
    currentStep,
    loading,
    stripeStatus,
    businessTypeMismatch,
    myProjects,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStripeStatus: (projectId) =>
    dispatch(PaymentActions.getStripeStatus(projectId)),
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
  getBusinessType: (projectId) =>
    dispatch(ProjectsActions.getBusinessType(projectId)),
  getMyProjects: () => dispatch(ProjectsActions.getMyProjects()),
  linkExistingStripeAccount: (projectId, accountId, user) =>
    dispatch(PaymentActions.linkExistingStripeAccount(projectId, accountId, user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Submission);
